import { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';

/**
 * DP275-P4a — a QR code, drawn where it is asked for.
 *
 * The same library the Work Table's label page uses, wrapped once so a card
 * can ask for a code by value and a size and get on with its day. The two
 * colours are the quiet-zone contract of a QR, not styling: a scanner needs
 * near-black on white, whatever the theme is doing.
 */
const opts = (value, size) => ({
  width: size,
  height: size,
  data: value,
  margin: 0,
  qrOptions: { errorCorrectionLevel: 'M' },
  dotsOptions: { type: 'square', color: 'black' },
  backgroundOptions: { color: 'white' },
});

/** The code on its own, big enough to paste on any label or sign. */
export const downloadQR = (value, code) =>
  new QRCodeStyling(opts(value, 1024)).download({ name: code, extension: 'png' });

export const QR = ({ value, size = 44 }) => {
  const holder = useRef(null);

  useEffect(() => {
    const node = holder.current;
    if (!node || !value) return undefined;
    node.innerHTML = '';
    const qr = new QRCodeStyling(opts(value, size));
    qr.append(node);
    return () => { node.innerHTML = ''; };
  }, [value, size]);

  return <div ref={holder} style={{ width: size, height: size }} aria-hidden="true" />;
};

export default QR;
